import { render, staticRenderFns } from "./footerTab.vue?vue&type=template&id=fbd337c2&scoped=true&"
import script from "./footerTab.vue?vue&type=script&lang=js&"
export * from "./footerTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd337c2",
  null
  
)

export default component.exports